const levels = [
  { label: 'A', value: 'a' },
  { label: 'B', value: 'b' },
  { label: 'C', value: 'c' },
  { label: 'D', value: 'd' },
  { label: 'E', value: 'e' },
  { label: 'F', value: 'f' }
]

export default levels



// WEBPACK FOOTER //
// ./src/modules/Students/Constants/levels.js